import script from "./CompatibilityWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./CompatibilityWarning.vue?vue&type=script&setup=true&lang=js"

import "./CompatibilityWarning.vue?vue&type=style&index=0&id=5f8ac8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_nnqy633ba33w3ap4lrqhdb3em4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8ac8fc"]])

export default __exports__